<template>
	<v-app>
		<v-content>
        <div class="px-3">
					<div class="mt-4 px-4 text-center">
						<h2 class="font-weight-bold mb-10">本当に退会しますか？</h2>
					</div>
          <div class="py-10 text-left">
            この画面は「{{ $route.query.appDisplayName }}」からアプリ会員退会する際の手続きです。退会すると、アプリからの配信などを受け取ることができなくなり、<span class="maincolor-font-danger">アカウントの全てのデータは削除されます。</span> <br />
            ご利用履歴の確認、アカウントの復元もできません。 <br />
            退会をご希望される方は、「退会する」ボタンをタップしてください。
          </div>
          <div class="mt-4 px-4 text-center">
            <v-btn rounded class="maincolor-btn-danger default_button mb-5" @click.stop="unregist()" :disabled="btnDisabledFlg">退会する</v-btn>
          </div>
        </div>
    </v-content>
    <v-overlay :value="loading">
      <v-progress-circular :size="80" :width="2" class="maincolor" indeterminate></v-progress-circular>
    </v-overlay>

  </v-app>
</template>

<script>
export default {
  props: [],
  data() {
    return {
      loading: false,
      btnDisabledFlg: false
    };
  },
  async created () {

  },
  methods: {
    unregist: function() {
		let callUnregist = async () => {
			try {
				//多重処理防止
				if (this.btnDisabledFlg) return;
				this.loading = true;
				this.btnDisabledFlg = true;

				//ユーザー本登録API
				var auth_req = {
					'sid': this.storageGet('sid'),
					'service_cd': this.storageGet('service_cd'),
					'login_id': this.storageGet('login_id'),
				}
				if(this.storageGet('login_id') != false){
					await this.apiCall('/unregist-user', auth_req, 'post', 2);
				}

				await this.apiCall('/user/unregist', auth_req, 'post');
				this.storageDelete('*');

				var tonative_req = {
					'destination': this.getDomain() + 'sp/unregist/end',
					'feature_id': 'unregist',
					'screen_id': 'unregist',
					'transition_type': 2,
					'page_title': '退会手続き',
					'cassette_id': 0,
					'top_type': 0,
				};

				this.screenTransition(tonative_req);
			} catch(e) {
				alert(e);
				this.callDialog('退会処理エラー', '時間を置いてから再度お試しください。', 3);
			} finally {
				// 正常, 異常に関わらず処理完了時はスピナー, ボタンdisabled解除
				this.loading = false;
				this.btnDisabledFlg = false;
			}
		}
		callUnregist();
    }
  }
}
</script>

<style scoped>
</style>
